export default {
  maxWidth: 320,
  direction: 'right',
  closeIconOptions: {
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    shadow: 'none',
  },
};
